import React from 'react'
import { Prompt } from 'react-router-dom'

export const PromptIfDirtyForm = (props) => {
    return <Prompt when={props.formik.dirty} message="You have unsaved data on this page. Are you sure you want to leave?" />
}

export default PromptIfDirtyForm;